interface Props {
  style?: React.CSSProperties;
  xFeet?: number;
  yFeet?: number;
}

export const LandingPointVis: React.FC<Props> = ({ style, xFeet, yFeet }) => {
  const strokeFill = "#6B7280"; // gray-500
  const ballFill = "#3B82F6"; // blue-500

  return (
    <svg
      style={style || { width: "100%" }}
      viewBox="0 0 650 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Landing zone is mapped so that 1px = 1foot on the field of play.
          x-axis runs along bottom of SVG, origin is at home plate, where -x territory
          is anything left of home, +x is anything right of home. Y axis origin is at
          center of home plate and extends positively thru center field. Data objects
          gives us (x,y) and we simply plot it on the field SVG. Field SVG coordinates
          are opposite of how the data gives it to us: Origin for SVG is the top left
          corner, which is (0,0), and so that's why we have to add 325 to xFeet and why
          we have to subtract 500 (which is homerun territory) and the yFeet coordinate. */}

      {yFeet && xFeet && (
        <circle
          style={{ zIndex: 10000 }}
          cx={325 + xFeet}
          cy={500 - yFeet}
          r="10.5"
          fill={ballFill}
        />
      )}

      <path
        d="M348.725 471.262L554.449 267.74"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="288.013"
        y2="-1"
        transform="matrix(-0.711273 -0.702916 0.711273 -0.702916 301.388 470.518)"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M318 481.277H331V488.102L324.5 494.125L318 488.102V481.277Z"
        fill={strokeFill}
      />
      <rect
        x="300.089"
        y="470.516"
        width="11.9529"
        height="26.5629"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <rect
        x="336.965"
        y="470.516"
        width="11.9529"
        height="26.5629"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M96.5 269.793C140.928 150.232 226.25 100.801 326.382 100.802C415.559 100.802 512.4 152.675 553.5 268.804"
        stroke={strokeFill}
        strokeWidth="3"
      />
      <path
        d="M226 397.276C245.346 344.837 282.499 323.157 326.102 323.157C364.934 323.157 407.103 345.909 425 396.843"
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M307.956 93.4973H301.764V91.3733L307.146 83.4713H309.324V92.2733H310.854V93.4973H309.324V96.0713H307.956V93.4973ZM307.956 92.3093V84.6233H307.848L303.096 91.5893V92.3093H307.956ZM312.559 94.2713V85.2713L314.359 83.4713H319.543L321.343 85.2713V94.2713L319.543 96.0713H314.359L312.559 94.2713ZM318.931 94.8473L319.975 93.8213V85.7213L318.931 84.6953H314.971L313.927 85.7213V93.8213L314.971 94.8473H318.931ZM323.862 94.2713V85.2713L325.662 83.4713H330.846L332.646 85.2713V94.2713L330.846 96.0713H325.662L323.862 94.2713ZM330.234 94.8473L331.278 93.8213V85.7213L330.234 84.6953H326.274L325.23 85.7213V93.8213L326.274 94.8473H330.234ZM336.064 88.2773H334.444V87.1073H336.064V85.1093L337.63 83.5433H340.222V84.6953H338.206L337.396 85.4873V87.1073H340.222V88.2773H337.396V96.0713H336.064V88.2773ZM342.832 94.4153V88.2773H341.212V87.1073H342.868V84.1913H344.164V87.1073H346.972V88.2773H344.164V94.0013L345.064 94.9013H346.972V96.0713H344.488L342.832 94.4153Z"
        fill={strokeFill}
      />
      <path
        d="M560.539 268.19V266.786H561.907V267.74L562.807 268.622H566.623L567.523 267.74V264.986L566.659 264.122H563.059V262.898H566.659L567.523 262.034V259.352L566.623 258.47H562.915L562.015 259.352V260.306H560.647V258.902L562.303 257.246H567.235L568.891 258.902V262.43L567.793 263.51L568.891 264.608V268.19L567.235 269.846H562.195L560.539 268.19ZM570.963 268.19V266.786H572.331V267.74L573.231 268.622H577.047L577.947 267.74V264.986L577.083 264.122H573.483V262.898H577.083L577.947 262.034V259.352L577.047 258.47H573.339L572.439 259.352V260.306H571.071V258.902L572.727 257.246H577.659L579.315 258.902V262.43L578.217 263.51L579.315 264.608V268.19L577.659 269.846H572.619L570.963 268.19ZM581.747 268.046V259.046L583.547 257.246H588.731L590.531 259.046V268.046L588.731 269.846H583.547L581.747 268.046ZM588.119 268.622L589.163 267.596V259.496L588.119 258.47H584.159L583.115 259.496V267.596L584.159 268.622H588.119ZM593.95 262.052H592.33V260.882H593.95V258.884L595.516 257.318H598.108V258.47H596.092L595.282 259.262V260.882H598.108V262.052H595.282V269.846H593.95V262.052ZM600.717 268.19V262.052H599.097V260.882H600.753V257.966H602.049V260.882H604.857V262.052H602.049V267.776L602.949 268.676H604.857V269.846H602.373L600.717 268.19Z"
        fill={strokeFill}
      />
      <path
        d="M47.3249 268.348V266.944H48.6929V267.898L49.5929 268.78H53.4089L54.3089 267.898V265.144L53.4449 264.28H49.8449V263.056H53.4449L54.3089 262.192V259.51L53.4089 258.628H49.7009L48.8009 259.51V260.464H47.4329V259.06L49.0889 257.404H54.0209L55.6769 259.06V262.588L54.5789 263.668L55.6769 264.766V268.348L54.0209 270.004H48.9809L47.3249 268.348ZM57.7487 268.348V266.944H59.1167V267.898L60.0167 268.78H63.8327L64.7327 267.898V265.144L63.8687 264.28H60.2687V263.056H63.8687L64.7327 262.192V259.51L63.8327 258.628H60.1247L59.2247 259.51V260.464H57.8567V259.06L59.5127 257.404H64.4447L66.1007 259.06V262.588L65.0027 263.668L66.1007 264.766V268.348L64.4447 270.004H59.4047L57.7487 268.348ZM68.5326 268.204V259.204L70.3326 257.404H75.5166L77.3166 259.204V268.204L75.5166 270.004H70.3326L68.5326 268.204ZM74.9046 268.78L75.9486 267.754V259.654L74.9046 258.628H70.9446L69.9006 259.654V267.754L70.9446 268.78H74.9046ZM80.7353 262.21H79.1153V261.04H80.7353V259.042L82.3013 257.476H84.8933V258.628H82.8773L82.0673 259.42V261.04H84.8933V262.21H82.0673V270.004H80.7353V262.21ZM87.5029 268.348V262.21H85.8829V261.04H87.5389V258.124H88.8349V261.04H91.6429V262.21H88.8349V267.934L89.7349 268.834H91.6429V270.004H89.1589L87.5029 268.348Z"
        fill={strokeFill}
      />
      <rect x="316" y="432.854" width="17" height="2.96475" fill={strokeFill} />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 317 362.47)"
        fill={strokeFill}
        fillOpacity=".75"
      />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 254 425.718)"
        fill={strokeFill}
        fillOpacity=".75"
      />
      <rect
        width="10.9356"
        height="10.9356"
        transform="matrix(0.711273 -0.702916 0.711273 0.702916 380 425.718)"
        fill={strokeFill}
        fillOpacity=".75"
      />
    </svg>
  );
};
